/* eslint-disable camelcase,no-param-reassign,@typescript-eslint/no-unused-expressions */

xplenty.service('permissionService', [
  '$rootScope',
  'accountService',
  'Account',
  'PermPermissionStore',
  'PermPermissionStrategies',

  function ($rootScope, accountService, Account, PermPermissionStore, PermPermissionStrategies) {
    const permissionService = {};

    const permissionStrategies = angular.extend(
      {},
      {
        // Add permission strategies
        enableElement($element) {
          PermPermissionStrategies.enableElement($element);
          $element.off('click.permission');
          $element.addClass('authorized');
        },
        disableElement($element) {
          PermPermissionStrategies.disableElement($element);
          $element.on('click.permission', function (event) {
            event.preventDefault();
            event.stopPropagation();
          });
          $element.addClass('unauthorized');
        },
        readonlyElement($element) {
          $element.attr('readonly', 'readonly');
        },
        showElement($element) {
          PermPermissionStrategies.showElement($element);
        },
        hideElement($element) {
          PermPermissionStrategies.hideElement($element);
        },
      },
    );

    permissionService.initPermissionStrategies = function () {
      // Setup permission view strategies
      $rootScope.permissionStrategies = permissionStrategies;
    };

    permissionService.clear = function () {
      // Clear permissions
      PermPermissionStore.clearStore();
      // Clear accounts list
      this.setAccounts(null);
      this.current_account_id = null;
    };

    // Setting account_id with null, clears the permissions list
    permissionService.setCurrentAccount = function (account_id) {
      // Try to get permissions of the specified account id.
      let account = null;
      // Set current account if we don't have current account set or it's not the same as the one that we are trying to set.
      if (
        this.current_account_id == null ||
        (this.current_account_id != null && this.current_account_id !== account_id)
      ) {
        // Set current account id with the new requested account
        this.current_account_id = account_id;
        // Clear permissions store
        PermPermissionStore.clearStore();
        if (account_id != null) {
          // Set permissions for requested account id
          if (this.accounts != null) {
            account = _.findWhere(this.accounts, {
              account_id,
            });
            if (account != null) {
              $rootScope.$log.debug('Setting permissions for account ', account_id);
              if (account.permissions != null && account.permissions instanceof Array) {
                // Attaches the account that the permission service will use for permissions check
                PermPermissionStore.defineManyPermissions(account.permissions, function (permissionName) {
                  return _.contains(account.permissions, permissionName);
                });
              }
            }
          }
        }
      } else {
        $rootScope.$log.debug('Reusing permissions setting for account ', account_id);
      }
    };

    permissionService.setAccounts = function (accounts) {
      this.accounts = (accounts || []).map((item) => ({ ...item }));
    };

    permissionService.addAccount = function (account) {
      // Listen for new account events
      if (account != null && this.accounts != null) {
        const arr = this.accounts;
        const index = _.findIndex(arr, { account_id: account.account_id });
        index > -1 && index < arr.length ? (arr[index] = account) : arr.push(account);
      }
    };

    permissionService.removeAccount = function (account) {
      this.setAccounts(
        _.without(
          this.accounts,
          _.findWhere(this.accounts, {
            id: account.id,
          }),
        ),
      );
    };

    permissionService.hasPermission = function (account_id, permissionName) {
      // Try to get permissions of the specified account id.
      let account = null;
      // Set current account if we don't have current account set or it's not the same as the one that we are trying to set.
      if (account_id != null) {
        // Set permissions for requested account id
        if (this.accounts != null) {
          account = _.findWhere(this.accounts, {
            account_id,
          });
          if (account != null) {
            return _.contains(account.permissions, permissionName);
          }
        }
      }
      return false;
    };

    permissionService.init = function (accounts) {
      permissionService.initPermissionStrategies();
      permissionService.clear();
      permissionService.setAccounts(_.cloneDeep(accounts));
    };

    return permissionService;
  },
]);
